import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowTableData } from './table-enums.js';

const uncertaintyVectorsMap = new Map();

uncertaintyVectorsMap.set(KnowTableData.DepthMD, {
  key: KnowTableData.DepthMD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth MD',
});

uncertaintyVectorsMap.set(KnowTableData.TermName, {
  key: KnowTableData.TermName,
  unit: '',
  label: 'Term Name',
});

uncertaintyVectorsMap.set(KnowTableData.VectorType, {
  key: KnowTableData.VectorType,
  unit: '',
  label: 'Vector type',
});

uncertaintyVectorsMap.set(KnowTableData.VectorEX, {
  key: KnowTableData.VectorEX,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'e.X',
});

uncertaintyVectorsMap.set(KnowTableData.VectorEY, {
  key: KnowTableData.VectorEY,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'e.Y',
});

uncertaintyVectorsMap.set(KnowTableData.VectorEZ, {
  key: KnowTableData.VectorEZ,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'e.Z',
});

uncertaintyVectorsMap.set(KnowTableData.VectorEStarX, {
  key: KnowTableData.VectorEStarX,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'e*.X',
});

uncertaintyVectorsMap.set(KnowTableData.VectorEStarY, {
  key: KnowTableData.VectorEStarY,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'e*.Y',
});

uncertaintyVectorsMap.set(KnowTableData.VectorEStarZ, {
  key: KnowTableData.VectorEStarZ,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'e*.Z',
});

uncertaintyVectorsMap.set(KnowTableData.LegIndex, {
  key: KnowTableData.LegIndex,
  unit: '',
  label: 'Leg Index',
});

export {
  uncertaintyVectorsMap,
};
